export class ChecklistPage {
    taskAccordions: NodeListOf<HTMLElement>;
    siteItems: NodeListOf<HTMLElement>;
    studyItems: NodeListOf<HTMLElement>;
    selectedSiteId: number | null = null;
    selectedStudyId: number | null = null;
    searchBar: any;
    constructor() {
        $(() => {
            this.initialize();
        })
    }

    initialize() {
        var selectedSite = document.getElementById('siteDropdownButton');
        this.selectedSiteId = parseInt(selectedSite.dataset.siteId);

        var selectedStudy = document.getElementById('studyDropdownButton');
        this.selectedStudyId = parseInt(selectedStudy.dataset.studyId);

        this.bindSearchBar();
        this.bindSites();
        this.bindStudies();
        this.loadMilestones();
        //this.bindMilestones();
    }

    bindSearchBar() {
        this.searchBar = document.getElementById('siteSearch');
        if (this.searchBar) {
            this.searchBar.addEventListener("keyup", function () {
                const filter = this.value.toLowerCase();
                const items = document.querySelectorAll<HTMLElement>(".dropdown-item.site-item");

                items.forEach(item => {
                    const text = item.textContent.toLowerCase();
                    item.style.display = text.includes(filter) ? "" : "none";
                });
            });
        }
    }

    bindSites() {
        this.siteItems = document.querySelectorAll<HTMLElement>(".site-item");
        if (this.siteItems) {
            this.siteItems.forEach((item) => {
                $(item).on('click', () => {
                    const siteId = item.dataset.siteId;
                    if (!siteId) return;

                    this.selectedSiteId = parseInt(siteId);

                    const name = item.dataset.siteName;
                    const num = item.dataset.siteNum;

                    const btn = document.querySelector("#siteDropdownButton");
                    if (btn && name && num) {
                        btn.textContent = `${name} (${num})`;
                    } else if (btn && name) {
                        btn.textContent = `${name}`;
                    }

                    this.selectedStudyId = null;
                    const studyBtn = document.querySelector("#studyDropdownButton");
                    if (studyBtn) {
                        studyBtn.textContent = "Select Study";
                    }

                    this.loadStudies();
                });
            });
        }
    }

    async loadStudies() {
        if (!this.selectedSiteId) return;

        const response = await fetch(
            `/secure/site-checklist/site-checklist?handler=Studies&siteId=${this.selectedSiteId}`
        );

        if (!response.ok) {
            throw new Error(response.statusText);
        }

        const result = await response.json()

        const studyBtn = document.querySelector("#studyDropdownButton");
        studyBtn.classList.remove('disabled');

        if (Object.keys(result).length === 0) {
            studyBtn.classList.add('disabled');
            this.selectedStudyId = null;
            const milestones = document.querySelector("#milestones-container");
            milestones.innerHTML = `<div class="no-milestones">No Milestones to Display</div>`
            return;
        }
        const container = document.querySelector(".studies-dropdown");
        if (!container) return;

        let html = "";
        result.forEach((study: any) => {
            html += `
                <a class="dropdown-item study-item"
                data-study-id="${study.studyId}"
                data-study-name="${study.studyName}">
                    ${study.studyName}
                </a>
            `;
        });

        container.innerHTML = html;

        const milestones = document.querySelector("#milestones-container");
        milestones.innerHTML = `<div class="no-milestones">Select a Study</div>`

        this.bindStudies();
    }

    bindStudies() {
        this.studyItems = document.querySelectorAll<HTMLElement>(".study-item");
        if (this.studyItems) {
            this.studyItems.forEach((item) => {
                $(item).off('click').on('click', () => {
                    const studyId = item.dataset.studyId;
                    if (!studyId) return;

                    this.selectedStudyId = parseInt(studyId);

                    const name = item.dataset.studyName;
                    const btn = document.querySelector("#studyDropdownButton");

                    if (btn && name) {
                        btn.textContent = name;
                    }

                    this.loadMilestones();
                });
            });
        }

    }

    async loadMilestones() {
        if (!this.selectedSiteId || !this.selectedStudyId) return;

        const response = await fetch(
            `/secure/site-checklist/site-checklist?handler=Milestones&siteId=${this.selectedSiteId}&studyId=${this.selectedStudyId}`,
            {
                method: 'GET'
            }
        );

        if (!response.ok) {
            throw new Error(response.statusText);
        }

        const result = await response.text();

        const container = document.querySelector("#milestones-container");

        container.innerHTML = result;

        this.bindMilestones();
    }

    bindMilestones() {
        this.taskAccordions = document.querySelectorAll<HTMLElement>('.task-container');

        this.taskAccordions.forEach((task) => {
            const child = task.firstElementChild as HTMLElement;
            const toggleId = child?.getAttribute('data-target');
            const toggleEl = task.querySelector<HTMLElement>(toggleId);
            if (!toggleEl) return;

            const setUi = (expanded: boolean) => {
                task.classList.toggle('open', expanded);
                const icon = child.querySelector<HTMLElement>(".toggle-icon");
                icon?.classList.toggle("open", expanded);
            }

            $(toggleEl).on('show.bs.collapse', () => setUi(true));
            $(toggleEl).on('hide.bs.collapse', () => setUi(false));
        });
    }

}